import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var MyProfileView = /** @class */ (function (_super) {
    tslib_1.__extends(MyProfileView, _super);
    function MyProfileView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.locales = ["fi", "se"];
        _this.user = store.currentUser;
        _this.changesSaved = false;
        _this.profilePictureUploading = false;
        _this.error = "";
        _this.invalidImageSelected = false;
        _this.profilePicture = null;
        return _this;
    }
    MyProfileView.prototype.profilePictureSelected = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var file, formData, allowedImageTypes, _a, _b, e_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        file = e.target.files[0];
                        if (!file)
                            return [2 /*return*/];
                        formData = new FormData();
                        formData.append("file", file);
                        allowedImageTypes = [
                            "image/png", "image/jpeg",
                        ];
                        if (!allowedImageTypes.some(function (type) { return type == file.type; })) {
                            this.invalidImageSelected = true;
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        this.invalidImageSelected = false;
                        this.profilePictureUploading = true;
                        _a = this.user;
                        return [4 /*yield*/, axios.post('users/me/profile-picture', formData, { headers: { "Content-Type": "multipart/form-data" } })];
                    case 2:
                        _a.profilePicture =
                            (_c.sent()).data;
                        _b = this;
                        return [4 /*yield*/, axios.get("users/me/profile-picture")];
                    case 3:
                        _b.profilePicture = (_c.sent()).data;
                        this.profilePictureUploading = false;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MyProfileView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        store.page.title = this.$t("myProfileView.title");
                        store.page.showTopNav = true;
                        _a = this;
                        return [4 /*yield*/, axios.get("users/me/profile-picture")];
                    case 1:
                        _a.profilePicture = (_b.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    MyProfileView.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.changesSaved = false;
                        return [4 /*yield*/, axios.put("users/" + store.currentUser.userId, this.user)];
                    case 1:
                        _a.sent();
                        this.changesSaved = true;
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.log(e_2.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MyProfileView.prototype.setLocale = function (locale) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$i18n.locale = locale;
                        store.currentUser.locale = locale;
                        return [4 /*yield*/, axios.put("users/" + store.currentUser.userId, store.currentUser)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyProfileView.prototype.instructions = function () {
        // this.$router.push("/instructions");
        this.$router.push("/mobile-app-instructions");
    };
    MyProfileView.prototype.privacySettings = function () {
        this.$router.push("/privacy-settings");
    };
    MyProfileView.prototype.logout = function () {
        localStorage.removeItem("accessToken");
        location.reload(); // TODO
    };
    MyProfileView = tslib_1.__decorate([
        Component
    ], MyProfileView);
    return MyProfileView;
}(Vue));
export default MyProfileView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/MyProfileView.vue
// module id = 67
// module chunks = 0